export const CATEGORIES = {
  online: { nom: 'Coaching Online', icon: '🌐', color: '#c4a050', bgColor: 'rgba(196,160,80,.12)' },
  presentiel: { nom: 'Coaching Présentiel', icon: '📍', color: '#2a9d5c', bgColor: 'rgba(42,157,92,.12)' },
  massage: { nom: 'Massothérapie', icon: '🤲', color: '#4a90d9', bgColor: 'rgba(74,144,217,.12)' },
  nutrition: { nom: 'Nutrition', icon: '🥗', color: '#7c5cbf', bgColor: 'rgba(124,92,191,.12)' },
};

export const NUTRITION_INITIAL_FORM = {
  // Contexte administratif uniquement. Cette valeur organise le dossier mais
  // ne choisit jamais un pack, une analyse ou une règle clinique.
  carePathway: '',
  // Etape 1 - Identite
  prenom: '',
  nom: '',
  age: '',
  genre: '',
  profession: '',
  poids: '',
  taille: '',
  tourTaille: '',
  tourHanche: '',
  tourPoitrine: '',
  tourBras: '',
  tourCuisse: '',
  masseGrasse: '',
  masseMusculaire: '',
  telephone: '',
  email: '',
  adresse: '',
  // Etape 2 - Antecedents medicaux
  antecedentsFamiliaux: '',
  pathologies: '',
  // 2026-07-31 — champ LEGACY. Conserve pour la migration douce voulue par
  // Anissa : la donnee deja saisie n'est ni supprimee ni ecrasee, et reste
  // affichee cote praticienne comme « information precedemment renseignee ».
  // Le questionnaire cliente ne pose plus cette question (remplacee par les
  // champs structures ci-dessous). A retirer plus tard, quand tout aura ete
  // reporte et verifie. Cf docs/MATRICE-CHAMPS-CLINIQUES-2026-07-31.md.
  traitements: '',
  operations: '',
  allergies: '',
  flagsProfilRisque: [],
  profilsRisqueVerifiesParAnissa: false,

  // ─── Sante et suivi medical (2026-07-31, valide par Anissa) ───────────
  // Diagnostics RECUS qui conditionnent les blocages de securite.
  // ⚠️ Une valeur VIDE ici signifie « non renseigne », JAMAIS « aucun
  // diagnostic » — « aucun » est une reponse explicite distincte. Ne jamais
  // initialiser ces champs a 'aucun' par defaut, ni les remplir
  // automatiquement depuis le texte libre.
  // 2026-08-01, arbitrage 3 d'Anissa : « insulinoresistance diagnostiquee »
  // est une reponse DISTINCTE. Elle ne doit PAS etre assimilee au prediabete.
  diabeteDiagnostic: '',      // aucun|type1|type2|gestationnel|prediabete|insulinoresistance|autre|jeNeSaisPas
  // 2026-08-01, arbitrage 4 d'Anissa : REPONSES MULTIPLES. Un SII et un RGO
  // coexistent frequemment ; l'ancien champ a reponse unique forcait la
  // cliente a choisir, et le sous-module de l'autre situation ne s'activait
  // jamais. Valeur = tableau. Les fiches existantes portent encore une
  // chaine : `resolveClinicalState` accepte les deux (migration douce).
  digestifDiagnostic: [],     // (aucun|sii|rgo|crohn|rch|autreMici|autre|jeNeSaisPas)[]
  miciStatut: '',             // remission|active|jeNeSaisPas  (si MICI declaree)
  thyroideDiagnostic: '',     // aucun|hypothyroidie|hashimoto|hyperthyroidie|basedow|autre|jeNeSaisPas
  thyroideStatut: '',         // oui|non|jeNeSaisPas  (si hyperthyroidie ou Basedow)
  traitementsActuels: '',     // oui|non
  traitementsDetail: '',      // noms exacts, un par ligne
  traitementsMomentPrise: '', // moment habituel de prise
  // Statut de verification — PRATICIENNE UNIQUEMENT, jamais rempli par la
  // cliente et jamais affiche dans l'app cliente. Le formulaire Anissa le
  // scelle uniquement au clic final de sauvegarde, puis l'invalide à l'édition.
  traitementsVerifiesParAnissa: '', // '' | 'oui'
  traitementsVerifiesLe: '',        // ISO date
  medecinTraitant: '',
  dernierDetartrage: '',
  // Liste explicite [{ nom, dose }]. [] signifie « non renseigné » ;
  // l'absence déclarée est stockée comme [{ nom: 'Aucun', dose: '' }].
  complementsActuels: [],
  // Préférence déclarée concernant les compléments. Le vide signifie
  // « non renseigné » : aucune valeur ne doit être présélectionnée ou déduite.
  ouvertureComplements: '', // eviter|si_necessaire|a_laise
  // Confirmations explicites requises avant génération. Les valeurs restent
  // volontairement vides : aucune réponse clinique n'est présélectionnée.
  restrictionsAlimentaires: [], // aucune|halal|casher|vegetarien|vegan|autre
  restrictionsAutre: '',
  ramadanActif: '', // false après confirmation explicite ; true jamais activé depuis cette UI
  presentationSansChiffres: '', // boolean confirmé par Anissa
  // Etape 3 - Alimentation
  nbRepas: '',
  alimentsEvites: '',
  hydratation: '',
  mastication: '',
  regimesSuivis: '',
  // Etape 4 - Sante
  blessures: '',
  douleursActuelles: '',
  contraception: '',
  cycleDuree: '',
  spm: '',
  douleursMenstruelles: '',
  projetGrossesse: '',
  // Etape 5 - Sport & Performance
  typeSport: '',
  frequenceSport: '',
  objectifSport: '',
  recuperation: '',
  supplements: '',
  digestifEffort: '',
  // Etape 6 - Metabolisme & Energie
  energieJournee: '',
  fringalesSucre: '',
  variationsGlycemie: '',
  reactionGlucides: [],
  // Etape 7 - Digestion & Microbiote
  frequenceBallonnements: '',
  transitType: '',
  alimentsProblematiques: '',
  consommationReguliere: [],
  // V97.4 V3.H Gap #1 — Pression antibiotique (impact microbiote majeur).
  // Consommé par detectMicrobiomeStage via microbiomeSignals.getFormAntibioticSignals.
  antibiotiques_recents: '',          // 'aucun' | 'moins_3_mois' | 'moins_12_mois' | 'plus_12_mois'
  antibiotiques_frequence_12mois: '', // 'aucune' | '1_cure' | '2_3_cures' | '4_plus_cures'
  antifongiques_recents: '',          // 'oui_12_mois' | 'non'
  infections_recurrentes: '',         // 'aucune' | 'occasionnelles' | 'frequentes'
  // V97.4 V3.H Gap #2 — Transit détaillé (le moteur microbiome y est sensible).
  // Consommé par detectMicrobiomeStage via microbiomeSignals.getFormTransitSignals.
  frequence_selles: '',         // 'moins_3_par_semaine' | '3_6_par_semaine' | '1_par_jour' | '2_3_par_jour' | 'plus_3_par_jour'
  bristol_selles: '',           // '1_2' (dures) | '3_4' (normales) | '5' (molles) | '6_7' (liquides)
  douleurs_digestives: '',      // 'non' | 'occasionnelles' | 'frequentes'
  reflux: '',                   // 'non' | 'occasionnel' | 'frequent'
  ballonnements_post_repas: '', // 'non' | 'occasionnels' | 'frequents'
  // Etape 8 - Inflammation & Immunite
  douleursInflammations: '',
  frequenceMaladies: '',
  troublesPeau: '',
  // Etape 9 - Stress & Systeme nerveux
  niveauStressActuel: '5',
  difficultesEndormissement: '',
  reveilsNocturnes: '',
  etatReveil: '',
  // Etape 10 - Mode de vie & Biohacking
  tempsExterieur: '',
  heuresSommeil: '',
  expositionEcransSoir: '',
  professionType: '',
  alcool: '',
  tabac: '',
  // Etape 11 - Genetique & Donnees
  analysesBiologiques: '',
  testADN: '',
  testsGenetiques: '',
  pretAnalysesAvancees: '',
  // Etape 12 - Objectifs & Engagement
  objectifPrincipalNutrition: '',
  dureeProbleme: '',
  dejaEssaye: '',
  pretProtocole: '',
  // V97.4 V3.H Gap #3 — Objectifs structurés priorisés (focus plan IA).
  // L'IA reçoit ces champs en bloc dédié pour produire un plan ciblé
  // sur la priorité 1 (au lieu de plans "larges" actuels).
  objectif_primaire: '',          // textarea libre (ex: "Perdre 8 kg", "Récupérer énergie")
  objectif_secondaire_1: '',      // textarea libre (en support)
  objectif_secondaire_2: '',      // textarea libre (en support)
  objectif_urgency: '',           // 'urgent_moins_1m' | 'moyen_3_6m' | 'long_terme'
  // Etape 13 - Notes nutritionniste
  observationsGenerales: '',
  planAction: '',
  examensPrevoir: '',
};

export const SYMPTOMES_OBJECTIFS_OPTIONS = [
  'Fertilite', 'Digestif', 'Sport', 'Fatigue', 'Poids', 'Hormonaux', 'Immunite', 'Autre',
];

export const STEPS = [
  { id: 1, label: 'Identite', title: 'Identite du client' },
  { id: 2, label: 'Objectifs', title: 'Objectifs' },
  { id: 3, label: 'Sport', title: 'Activite sportive' },
  { id: 4, label: 'Sante', title: 'Sante' },
  { id: 5, label: 'Nutrition', title: 'Nutrition' },
  { id: 6, label: 'Lifestyle', title: 'Mode de vie' },
  { id: 7, label: 'Contexte', title: 'Contexte coaching' },
  { id: 8, label: 'Mes notes', title: 'Notes du coach' },
];

export const PRESENTIEL_STEPS = [
  { id: 1, label: 'Identite', title: 'Identite du client' },
  { id: 2, label: 'Objectifs', title: 'Objectifs' },
  { id: 3, label: 'Sport', title: 'Activite sportive' },
  { id: 4, label: 'Sante', title: 'Sante' },
  { id: 5, label: 'Nutrition', title: 'Nutrition' },
  { id: 6, label: 'Lifestyle', title: 'Mode de vie' },
  { id: 7, label: 'Mes notes', title: 'Notes du coach' },
];

export const MASSAGE_STEPS = [
  { id: 1, label: 'Identite', title: 'Identite' },
  { id: 2, label: 'Douleurs', title: 'Motif et douleurs' },
  { id: 3, label: 'Sante', title: 'Sante' },
  { id: 4, label: 'Preferences', title: 'Preferences' },
  { id: 5, label: 'Notes', title: 'Notes du therapeute' },
];

export const INITIAL_FORM = {
  prenom: '',
  langue: 'FR',
  formule: 'suivi',
  customRate: '',
  age: '',
  genre: '',
  poids: '',
  taille: '',
  tourTaille: '',
  tourHanche: '',
  tourCou: '',
  tourPoitrine: '',
  tourBrasDroit: '',
  tourBrasGauche: '',
  tourCuisseDroite: '',
  tourCuisseGauche: '',
  tourMollet: '',
  objectifPrincipal: '',
  objectifSecondaire: '',
  deadline: '',
  motivationProfonde: '',
  niveau: '',
  frequence: '',
  duree: '',
  lieu: '',
  equipement: '',
  historique: '',
  exercicesAimes: '',
  exercicesEvites: '',
  blessures: '',
  problemesSante: '',
  medicaments: '',
  objectifNutrition: '',
  allergies: '',
  preferencesAlimentaires: '',
  frequenceRestaurant: '',
  niveauCuisine: '',
  sommeil: '',
  stress: '',
  travail: '',
  alcool: '',
  hydratation: '',
  dejaCoach: '',
  appsFitness: '',
  pasMarche: '',
  attentes: '',
  notesCoach: '',
};

export const PRESENTIEL_INITIAL_FORM = {
  prenom: '',
  langue: 'FR',
  pack: 'pack10',
  benoitSessionsTotal: '',
  benoitPackPrice: '',
  benoitPackLabel: '',
  age: '',
  genre: '',
  poids: '',
  taille: '',
  tourTaille: '',
  tourHanche: '',
  tourCou: '',
  tourPoitrine: '',
  tourBrasDroit: '',
  tourBrasGauche: '',
  tourCuisseDroite: '',
  tourCuisseGauche: '',
  tourMollet: '',
  objectifPrincipal: '',
  objectifSecondaire: '',
  deadline: '',
  motivationProfonde: '',
  niveau: '',
  frequence: '',
  duree: '',
  lieu: '',
  equipement: '',
  historique: '',
  exercicesAimes: '',
  exercicesEvites: '',
  blessures: '',
  problemesSante: '',
  medicaments: '',
  objectifNutrition: '',
  allergies: '',
  preferencesAlimentaires: '',
  frequenceRestaurant: '',
  niveauCuisine: '',
  sommeil: '',
  stress: '',
  travail: '',
  alcool: '',
  hydratation: '',
  notesCoach: '',
};

export const MASSAGE_INITIAL_FORM = {
  prenom: '',
  nom: '',
  age: '',
  genre: '',
  telephone: '',
  customRate: '120',
  email: '',
  motifConsultation: '',
  zonesDouloureuses: [],
  typeDouleur: '',
  intensiteDouleur: '',
  dureeDouleur: '',
  traitementsEnCours: '',
  medicaments: '',
  operationsRecentes: '',
  contreIndications: [],
  allergiesMassage: '',
  pressionPreferee: '',
  zonesAEviter: '',
  dejaMassage: '',
  frequenceSouhaitee: '',
  objectifMassage: [],
  notesCoach: '',
};

export const PRESENTIEL_PACKS = {
  pack10: { nom: 'Pack 10 séances', prix: '750 CHF' },
  pack20: { nom: 'Pack 20 séances', prix: '1400 CHF' },
  pack30: { nom: 'Pack 30 séances', prix: '1950 CHF' },
};

export const FORMULES = {
  autonome: { nom: 'Autonome', prix: '150 CHF/mois', montant: 150 },
  suivi: { nom: 'Suivi Complet', prix: '350 CHF/mois', montant: 350 },
  intensif: { nom: 'Intensif', prix: '600 CHF/mois', montant: 600 },
  pack10: { nom: 'Pack 10', prix: "1'200 CHF", montant: 1200 },
  // V96.30 — label neutre (anciennement "Pack 20 Seances" / "Pack 30 Seances").
  // Le mot "Seances" sonnait Presentiel et apparaissait sur les cards des
  // clientes Coaching Online (Ana, Rebecca) ce qui creait une confusion. Le
  // contexte (badge categorie de la card) clarifie deja s'il s'agit de
  // seances IRL ou suivi distance.
  pack20: { nom: 'Pack 20', prix: "2'200 CHF", montant: 2200 },
  pack30: { nom: 'Pack 30', prix: "3'000 CHF", montant: 3000 },
  massage: { nom: 'Massotherapie', prix: '120 CHF/h', montant: 120 },
  custom: { nom: 'Tarif personnalise', prix: 'Personnalise', montant: 0 },
};

export const FORMULE_OPTIONS_FR = [
  { value: 'autonome', label: 'Autonome - 150 CHF/mois' },
  { value: 'suivi', label: 'Suivi Complet - 350 CHF/mois' },
  { value: 'intensif', label: 'Intensif - 600 CHF/mois (3 mois)' },
  { value: 'pack10', label: "Pack 10 Seances - 1'200 CHF" },
  { value: 'pack20', label: "Pack 20 - 2'200 CHF" },
  { value: 'pack30', label: "Pack 30 - 3'000 CHF" },
  { value: 'massage', label: 'Massotherapie - 120 CHF/h' },
  { value: 'custom', label: 'Tarif personnalise' },
];

export const FORMULE_OPTIONS_EN = [
  { value: 'autonome', label: 'Autonome - 150 CHF/month' },
  { value: 'suivi', label: 'Full Support - 350 CHF/month' },
  { value: 'intensif', label: 'Intensive - 600 CHF/month (3 months)' },
  { value: 'pack10', label: "Pack 10 Sessions - 1'200 CHF" },
  { value: 'pack20', label: "Pack 20 - 2'200 CHF" },
  { value: 'pack30', label: "Pack 30 - 3'000 CHF" },
  { value: 'massage', label: 'Massage Therapy - 120 CHF/h' },
  { value: 'custom', label: 'Custom Rate' },
];

export function getFormuleOptions(langue) {
  return langue === 'EN' ? FORMULE_OPTIONS_EN : FORMULE_OPTIONS_FR;
}

export const ZONES_DOULOUREUSES_OPTIONS = [
  'Cou', 'Epaules', 'Dos haut', 'Dos bas', 'Lombaires',
  'Hanches', 'Jambes', 'Bras', 'Tete', 'Autre',
];

export const CONTRE_INDICATIONS_OPTIONS = [
  'Phlebite', 'Inflammation aigue', 'Fievre', 'Blessure recente',
  'Grossesse', 'Problemes de peau', 'Cancer',
];

export const OBJECTIF_MASSAGE_OPTIONS = [
  'Detente', 'Recuperation sportive', 'Soulagement douleur', 'Mobilite',
];
